import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  input,
  ViewEncapsulation,
} from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'orbit-dialog-header',
  standalone: true,
  imports: [NgClass],
  templateUrl: './dialog-header.component.html',
  styleUrl: './dialog-header.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DialogHeaderComponent {
  title = input<string>();
  centerTitle = input<boolean, unknown>(false, { transform: booleanAttribute });
  rounded = input<boolean, unknown>(false, { transform: booleanAttribute });
  transparent = input<boolean, unknown>(false, { transform: booleanAttribute });
}
